module.exports = require('./backbone-events-standalone');



//////////////////
// WEBPACK FOOTER
// ./~/backbone-events-standalone/index.js
// module id = 1440
// module chunks = 0